import WrapperProvider from "@providers/WrapperProvider";
import StoryContainer from "@containers/StoryContainer";
import LocomotiveProvider from "@providers/LocomotiveProvider";
import _ from "lodash";
import { getServer } from "@translations/next";
import StoryArticleService from "@services/StoryArticleService";
import StoryCategoryService from "@services/StoryCategoryService";
import Layout from "@components/Layout";
import FooterService from "@services/FooterService";

export default function View(props: any) {
  return (
    <WrapperProvider pageContext={props}>
      <Layout>
        <LocomotiveProvider
          options={{
            smooth: true,
            getSpeed: true,
            getDirection: true,
            reloadOnContextChange: true,
            mobile: {
              smooth: true,
            },
            tablet: {
              smooth: true,
            },
          }}
        >
          <StoryContainer />
        </LocomotiveProvider>
      </Layout>
    </WrapperProvider>
  );
}

export const getServerSideProps = getServer(async ({ params }) => {
  const locale: any = _.get(params, "locale", "en");

  const resCategory = await StoryCategoryService.find({
    locale,
    populate: "deep",
  });
  const res = await StoryArticleService.find({
    populate: ["category", "thumbnail"],
    page: 1,
    pageSize: 6,
    locale,
    filters: {
      hotels: {
        slug: {
          $eq: "amanaki-thao-dien",
        },
      },
    },
    sort: 'publishedAt:desc'
  });
  const footerData = await FooterService.fetchByHotel("amanaki-thao-dien", locale);
  return {
    hotel: "amanaki-thao-dien",
    categories: _.get(resCategory, "data", null),
    articles: _.get(res, "data", []),
    footerData,
  };
});
